module.exports = __webpack_public_path__ + "img/guide_dir_04.73494f1a.png";